import React from 'react';
import ReactModal from 'react-modal';

import { Flex } from '@rover/kibble/core';
import {
  usePreventScroll,
  useReactModalSetup,
} from '@rover/kibble/official-patterns/Modal/Modal.common';

import useOverlayFocus from './hooks/useOverlayFocus';
import { overlayCommonProps, OverlayProps } from './Overlay.common';

const APP_ELEMENT_SELECTOR = '#base-content';

const Overlay = ({
  children,
  collapseMobilePx,
  onClose,
  ariaLabel,
  centerVertically,
}: OverlayProps): JSX.Element => {
  const { modalId } = useReactModalSetup(APP_ELEMENT_SELECTOR);
  usePreventScroll(true, modalId);

  const { contentRef } = useOverlayFocus();

  return (
    <ReactModal
      isOpen
      shouldReturnFocusAfterClose={false}
      shouldFocusAfterRender={false}
      contentRef={contentRef}
      onRequestClose={onClose}
      contentLabel={ariaLabel}
      style={{
        overlay: { display: 'contents' },
        content: { display: 'contents' },
      }}
    >
      <Flex
        {...overlayCommonProps}
        alignItems={centerVertically ? 'stretch' : 'start'}
        position="fixed"
        width="100vw"
        sx={{
          ...overlayCommonProps.sx,
          overflowY: 'scroll',
          px: collapseMobilePx ? ['0x', '4x'] : overlayCommonProps.sx.px,
        }}
      >
        {children}
      </Flex>
    </ReactModal>
  );
};

export default Overlay;
